import { makeStyles } from "@mui/styles";

const dynamicStyle = makeStyles((theme) => ({
  box: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "80vh",
  },
  link: {
    textDecoration: "none",
  },
}));

export default dynamicStyle;
